export const formatPrice = (price) => {
    let formattedPrice = new Intl.NumberFormat('en-SG', {
        style: 'currency',
        currency: 'SGD',
    }).format(price);
    return formattedPrice;
}